var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52218 8.80999C6.97831 8.80999 7.34807 8.44022 7.34807 7.9841C7.34807 7.52797 6.97831 7.1582 6.52218 7.1582C6.06605 7.1582 5.69629 7.52797 5.69629 7.9841C5.69629 8.44022 6.06605 8.80999 6.52218 8.80999Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00167 13.2139C7.43867 13.2139 6.12413 12.1977 5.70808 10.8109C5.69645 10.7697 5.69461 10.7263 5.70273 10.6841C5.71084 10.642 5.72867 10.6024 5.75481 10.5684C5.78095 10.5344 5.81467 10.507 5.85327 10.4884C5.89188 10.4697 5.93431 10.4603 5.97719 10.461H12.0231C12.0659 10.4603 12.1084 10.4697 12.147 10.4884C12.1856 10.507 12.2193 10.5344 12.2454 10.5684C12.2716 10.6024 12.2894 10.642 12.2975 10.6841C12.3056 10.7263 12.3038 10.7697 12.2922 10.8109C11.8796 12.1977 10.5647 13.2139 9.00167 13.2139Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4777 8.80999C11.9339 8.80999 12.3036 8.44022 12.3036 7.9841C12.3036 7.52797 11.9339 7.1582 11.4777 7.1582C11.0216 7.1582 10.6519 7.52797 10.6519 7.9841C10.6519 8.44022 11.0216 8.80999 11.4777 8.80999Z",
    fill: "#828282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 15.9668C12.9531 15.9668 16.1578 12.7622 16.1578 8.8091C16.1578 4.856 12.9531 1.65137 9.00002 1.65137C5.04691 1.65137 1.84229 4.856 1.84229 8.8091C1.84229 12.7622 5.04691 15.9668 9.00002 15.9668Z",
    stroke: "#828282",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.59c2bd66fa12764e4bbd063576fae846.svg";
export { ForwardRef as ReactComponent };